<div [ngClass]="opens == 'right' ? 'left icon' : 'icon'" [class.disabled]="disabled" class="ui input">
  <input #elementRef type="daterange" [readonly]="!editable" (blur)="onBlur()">
  <i class="calendar alternate outline icon"></i>
</div>
